import React, { Component } from "react";
import { Header, Icon, Divider, Container, Image } from "semantic-ui-react";
import content from "./content";

class HomePage extends Component {
  render() {
    return (
      <div>
        <Header as="h1" icon textAlign="center">
          <Icon name="group" circular />
          <Header.Content>{content.title}</Header.Content>
        </Header>
        <Divider />
        <Container textAlign="center">
          {content.texte}
          <Image
            style={{
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
              width: "18%"
            }}
            src={require("./cs.png")}
          />
        </Container>
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/scenes/HomePage/index.js